// I've decided to do this page NOT by venue, but just a long list
import React, { useEffect, useState } from 'react'
import './FullSchedule.css'
import './FullScheduleCards.css'
import { Link, useParams } from 'react-router-dom'
import Footer from '../components/UIElements/Footer'
import SchedulesHomeNavigation from '../components/Navigation/SchedulesHomeNavigation'
import FilterByTeam from '../components/UIElements/FilterByTeam'
import LoadingSpinner from '../components/UIElements/LoadingSpinner'
import murrysvilleLogo from '../../images/MurrysvilleSportzone.png'

const LeagueSchedule = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [allLeagueGames, setAllLeagueGames] = useState([])
	const [divisionName, setDivisionName] = useState()
	const [showPreviousGames, setShowPreviousGames] = useState(false)

	const leagueId = useParams().leagueId

	console.log('inside LeagueSchedule.js')

	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			setAllLeagueGames([])

			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/schedule/${leagueId}`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setAllLeagueGames(responseData.allLeagueGamesArray)
				setDivisionName(responseData.divisionName)
			} catch (err) {
				console.log(err.message)
			}

			setIsLoading(false)
		}

		sendRequest()
	}, [leagueId])

	const formatGameDate = (game) => {
		const months = {
			'01': 'Jan.',
			'02': 'Feb.',
			'03': 'Mar.',
			'04': 'Apr.',
			'05': 'May',
			'06': 'June',
			'07': 'July',
			'08': 'Aug.',
			'09': 'Sept.',
			10: 'Oct.',
			11: 'Nov.',
			12: 'Dec.',
		}

		return `${game.dayOfWeek}, ${
			months[game.date.substr(0, 2)]
		} ${game.date.substr(3, 2)}`
	}

	const formatGameTime = (game) => {
		const hour = game.time.substr(0, 2)
		const minute = game.time.substr(3, 2)

		const times = {
			'00': `12:${minute} am`,
			'01': `1:${minute} am`,
			'02': `2:${minute} am`,
			'03': `3:${minute} am`,
			'04': `4:${minute} am`,
			'05': `5:${minute} am`,
			'06': `6:${minute} am`,
			'07': `7:${minute} am`,
			'08': `8:${minute} am`,
			'09': `9:${minute} am`,
			10: `10:${minute} am`,
			11: `11:${minute} am`,
			12: `12:${minute} pm`,
			13: `1:${minute} pm`,
			14: `2:${minute} pm`,
			15: `3:${minute} pm`,
			16: `4:${minute} pm`,
			17: `5:${minute} pm`,
			18: `6:${minute} pm`,
			19: `7:${minute} pm`,
			20: `8:${minute} pm`,
			21: `9:${minute} pm`,
			22: `10:${minute} pm`,
			23: `11:${minute} pm`,
			24: `12:${minute} am`,
		}

		return times[hour]
	}

	const getDisplayScore = (game) => {
		if (!game.score) {
			return 'TBP'
		}

		const scoreParts = game.score.split('-').map((score) => score.trim())

		if (scoreParts.length !== 2) {
			return game.score
		}

		const firstScore = Number(scoreParts[0])
		const secondScore = Number(scoreParts[1])

		if (Number.isNaN(firstScore) || Number.isNaN(secondScore)) {
			return game.score
		}

		/*
			Mobile cards display:

			HOME SCORE - VISITOR SCORE
		*/

		if (game.winner === game.homeTeamId) {
			return `${Math.max(firstScore, secondScore)} - ${Math.min(
				firstScore,
				secondScore,
			)}`
		}

		if (game.winner === game.visitorTeamId) {
			return `${Math.min(firstScore, secondScore)} - ${Math.max(
				firstScore,
				secondScore,
			)}`
		}

		return `${firstScore} - ${secondScore}`
	}

	const getGameStatus = (game) => {
		if (!game.score) {
			return ''
		}

		if (game.status === 'Shootout') {
			return 'SO'
		}

		if (game.status === 'Overtime') {
			return 'OT'
		}

		return 'FINAL'
	}
	//
	//
	const getGameDateObject = (game) => {
		if (!game.date) {
			return null
		}

		const splitDate = game.date.split('-')

		const month = parseInt(splitDate[0], 10) - 1
		const day = parseInt(splitDate[1], 10)
		const year = parseInt(splitDate[2], 10)

		return new Date(year, month, day)
	}

	const isGameOlderThanTwoDays = (game) => {
		const gameDate = getGameDateObject(game)

		if (!gameDate) {
			return false
		}

		// Do NOT hide old games that still need scored
		if (game.status === 'TBD') {
			return false
		}

		const today = new Date()
		today.setHours(0, 0, 0, 0)

		const twoDaysAgo = new Date(today)
		twoDaysAgo.setDate(today.getDate() - 2)

		return gameDate < twoDaysAgo
	}
	//
	//
	//
	if (isLoading) {
		return (
			<div className='center' style={{ marginTop: '10rem' }}>
				<LoadingSpinner />
			</div>
		)
	}

	if (allLeagueGames.length === 0) {
		return (
			<React.Fragment>
				<SchedulesHomeNavigation />
				<FilterByTeam />

				<div className='Leagues'>
					<h1>NOTHING SCHEDULED YET!</h1>
				</div>

				<div style={{ marginTop: '16rem' }}>
					<Footer />
				</div>
			</React.Fragment>
		)
	}

	const league = allLeagueGames[0]

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<SchedulesHomeNavigation leagueId={leagueId} />

				<div className='leagueScheduleDesktopFilter'>
					<FilterByTeam />
				</div>

				<div className='Schedule'>
					<div className='leagueScheduleDesktopHeading'>
						{!divisionName && (
							<div>
								<h1>{league.leagueName}</h1>

								<h4 className='h3Center'>
									{league.session} {league.year}
								</h4>
							</div>
						)}

						{divisionName && (
							<div>
								<h1>{league.leagueName}</h1>

								<h3 className='h3Center'>{divisionName} Division</h3>

								<h3 className='h3Center'>
									{league.session} {league.year}
								</h3>
							</div>
						)}

						<h1>League Schedule</h1>

						<p className='clickOn'>
							(Click on the final score of a game to see a Game Summary)
						</p>
					</div>

					<table id='leagueScheduleDisplay'>
						<thead>
							<tr>
								<th>Date/Time/Location</th>
								<th>Visitor/Home</th>
								<th></th>
								<th>Winner</th>
								<th>Score</th>
							</tr>
						</thead>

						<tbody>
							{allLeagueGames.map((game, key) => {
								return (
									<tr key={game._id || key}>
										<td>
											{formatGameDate(game)}
											<br />
											{formatGameTime(game)}
											<br />
											{game.venueName}
										</td>

										{game.visitorTeamName && (
											<td>
												{game.visitorTeamSeed > 0 &&
													`(${game.visitorTeamSeed}) `}
												{game.visitorTeamName}

												<br />

												{' @ '}

												<br />

												{game.homeTeamSeed > 0 && `(${game.homeTeamSeed}) `}
												{game.homeTeamName}

												{game.playoff && (
													<div
														style={{
															color: 'red',
															fontWeight: 'bold',
														}}
													>
														PLAYOFF GAME
													</div>
												)}

												{game.championship && (
													<div
														style={{
															color: 'red',
															fontWeight: 'bold',
														}}
													>
														CHAMPIONSHIP GAME
													</div>
												)}
											</td>
										)}

										<td>
											{game.summary && (
												<Link
													style={{
														textDecoration: 'none',
														fontWeight: 600,
														color: 'black',
													}}
													to={`/gameSummary/${game._id}`}
												>
													RECAP
												</Link>
											)}
										</td>

										{game.homeTeamId && game.winner === game.homeTeamId && (
											<td>{game.homeTeamName}</td>
										)}

										{game.visitorTeamId &&
											game.winner === game.visitorTeamId && (
												<td>{game.visitorTeamName}</td>
											)}

										{game.status &&
											game.status !== 'TBP' &&
											game.winner !== game.homeTeamId &&
											game.winner !== game.visitorTeamId && <td>TIE</td>}

										{!game.score && <td></td>}

										<td>
											{game.score && (
												<Link
													style={{
														textDecoration: 'none',
														fontWeight: 600,
														color: 'black',
													}}
													to={`/gameSummary/${game._id}`}
												>
													{game.score}
													{game.status === 'Overtime' && ' (OT)'}
													{game.status === 'Shootout' && ' (SO)'}
												</Link>
											)}
										</td>
									</tr>
								)
							})}
						</tbody>
					</table>

					<div className='leagueScheduleMobile'>
						<div className='leagueScheduleMobile__leagueCard'>
							<img
								src={murrysvilleLogo}
								alt='Murrysville Dek Hockey'
								className='leagueScheduleMobile__logo'
							/>

							<div className='leagueScheduleMobile__leagueName'>
								{league.leagueName}
							</div>

							<div className='leagueScheduleMobile__divider'></div>

							<div className='leagueScheduleMobile__season'>
								{league.session} {league.year}
							</div>

							{divisionName && (
								<div className='leagueScheduleMobile__division'>
									{divisionName} Division
								</div>
							)}

							<div className='leagueScheduleMobile__pageTitle'>
								League Schedule
							</div>

							<div className='leagueScheduleMobile__instructions'>
								(Click on a final score to see the Game Summary)
							</div>

							<div className='leagueScheduleMobile__filter'>
								<FilterByTeam />
							</div>
						</div>

						{allLeagueGames.some((game) => isGameOlderThanTwoDays(game)) && (
							<div
								onClick={() => setShowPreviousGames((prev) => !prev)}
								style={{
									textAlign: 'center',
									marginTop: '1rem',
									marginBottom: '1rem',
									fontSize: '0.85rem',
									fontWeight: '600',
									textDecoration: 'underline',
									cursor: 'pointer',
								}}
							>
								{showPreviousGames
									? 'Hide previous games'
									: 'Click to see previous games'}
							</div>
						)}

						<div className='scheduleCardsMobile leagueScheduleCardsMobile'>
							{allLeagueGames
								.filter((game) => {
									if (showPreviousGames) {
										return true
									}

									return !isGameOlderThanTwoDays(game)
								})
								.map((game, key) => {
									const isSpecialGame =
										game.playoff || game.championship || game.description

									return (
										<div
											className={`scheduleCard ${
												isSpecialGame ? 'scheduleCardSpecial' : ''
											}`}
											key={`league-schedule-mobile-${game._id || key}`}
										>
											<div className='scheduleCard__header'>
												<div>{formatGameDate(game)}</div>

												<div className='scheduleCard__league'>
													{game.championship
														? 'CHAMPIONSHIP'
														: game.playoff
															? 'PLAYOFF'
															: game.leagueName || 'Game'}
												</div>

												<div>{formatGameTime(game)}</div>
											</div>

											{game.homeTeamName && game.visitorTeamName ? (
												<>
													<div className='scheduleCard__body'>
														<div className='scheduleCard__team'>
															<span
																className={
																	game.winner === game.homeTeamId
																		? 'scheduleCard__winnerPill'
																		: ''
																}
															>
																{game.homeTeamSeed > 0 &&
																	`(${game.homeTeamSeed}) `}
																{game.homeTeamName}
															</span>
														</div>

														<div className='scheduleCard__scoreBox'>
															{game.score ? (
																<Link
																	to={`/gameSummary/${game._id}`}
																	className='scheduleCard__score'
																>
																	{getDisplayScore(game)}
																</Link>
															) : (
																<div className='scheduleCard__score'>TBP</div>
															)}

															{game.score && (
																<div className='scheduleCard__status'>
																	{getGameStatus(game)}
																</div>
															)}
														</div>

														<div className='scheduleCard__team'>
															<span
																className={
																	game.winner === game.visitorTeamId
																		? 'scheduleCard__winnerPill'
																		: ''
																}
															>
																{game.visitorTeamSeed > 0 &&
																	`(${game.visitorTeamSeed}) `}
																{game.visitorTeamName}
															</span>
														</div>
													</div>

													<div className='scheduleCard__venue'>
														📍 {game.venueName}
													</div>

													{game.description && (
														<div className='scheduleCard__description'>
															{game.description}
														</div>
													)}

													{game.championship && (
														<div className='scheduleCard__description'>
															CHAMPIONSHIP GAME
														</div>
													)}

													{game.playoff && !game.championship && (
														<div className='scheduleCard__description'>
															PLAYOFF GAME
														</div>
													)}
												</>
											) : (
												<>
													<div className='scheduleCard__event'>
														{game.eventName ||
															game.description ||
															'Scheduled Event'}
													</div>

													<div className='scheduleCard__venue'>
														📍 {game.venueName}
													</div>
												</>
											)}
										</div>
									)
								})}
						</div>
					</div>
				</div>

				<Footer />
			</React.Fragment>
		</div>
	)
}

export default LeagueSchedule
